import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/views/auth/shared/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  navigateTo(route: string): void {
    if (route === 'pass-on' && this.authService.isPartner()) {
      // If user is a partner, redirect directly to their repasse list
      const partnerId = this.authService.getPartnerId();
      if (partnerId) {
        this.router.navigate(['pass-on/show', partnerId]);
      } else {
        this.router.navigate([route]);
      }
    } else {
      this.router.navigate(route.split('/').filter((segment) => !!segment));
    }
  }
} 